export const uiTokens = {
    colors: {
        background: '#F8F3EB',
        surface: '#FFFCF8',
        surfaceMuted: '#F3ECE3',
        surfaceStrong: '#E7DDCF',
        border: '#D7CCBF',
        textPrimary: '#2A2521',
        textSecondary: '#5F5750',
        textMuted: '#9B9288',
        primary: '#7A4A2E',
        primaryDark: '#5F3923',
        successBg: '#EAF4EE',
        successText: '#2A5A4F',
        recommendationBg: '#EDF4F1',
        recommendationText: '#365F59',
        adaptiveBg: '#E8F1ED',
        adaptiveText: '#1F6458',
        adaptiveBorder: '#B9D2C9',
        warningBg: '#F4E6C5',
        warningText: '#A56F27',
        errorBg: '#FCE8E8',
        errorText: '#A32B2B',
        brand: '#2C1B12',
        brandModule: '#B7A58F',
        info: '#8FA89D',
    },
    shadow: {
        card: '0 14px 30px rgba(46, 42, 38, 0.10)',
        soft: '0 8px 20px rgba(46, 42, 38, 0.08)',
    },
    radius: {
        card: 4,
        chip: 999,
    },
}
